export default [
  {
    path: '/progress/:categoryId?',
    component: () => import('@views/progress/index'),
    name: 'progress',
  },
];
